import React, { useEffect, useState } from 'react';
import { useUploadDriverDetailsList } from '../../hooks/react-query/useDrivers';
import { MapperAll } from '../../utils/importDriver/mapper';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/Table';
import { ExportList, ExportListMobile } from '../elements/exportList';
import { PageList, PageListMobile } from '../elements/pageList';
import {
  exportToFile,
  generatePdfDocument,
} from '../../utils/importDriver/funtions';
import { TableSkeletion } from '../elements/skeletions';
import Container from '../elements/container';
import Pagination from '../elements/pagination/pagination';
import { BackButton } from '../ui';
import { exportOptions } from '../../utils/exports';
import Loader from '../elements/loader';

const ImportDriverDetailsTable = ({ queryData, handleBackButtonClick }) => {
  const [filter, setFilter] = useState({
    count: 25,
  });

  const {
    data: detailsTableData,
    isLoading,
    fetchNextPage,
  } = useUploadDriverDetailsList(filter);
  const [tableDetailsData, setTableData] = useState();
  const [popover, setPopover] = useState(false);
  const [popoverExport, setPopoverExport] = useState(false);
  const [popoverExportMobile, setPopoverExportMobile] = useState(false);
  const [sizeListPopoverMobile, setSizeListMobile] = useState(false);

  useEffect(() => {
    if (queryData.id) {
      setFilter({
        id: queryData.id,
        count: 25,
      });
    }
  }, [queryData.id]);

  useEffect(() => {
    if (detailsTableData) {
      const pages = detailsTableData.pages;
      setTableData(MapperAll(pages[pages.length - 1]));
    }
  }, [detailsTableData]);

  if (isLoading && !tableDetailsData) {
    return (
      <Container className="max-lg:px-0">
        <TableSkeletion />
      </Container>
    );
  }

  if (!tableDetailsData || !tableDetailsData?.data) {
    return (
      <TableBody>
        <TableRow key={'detailsTable'}>
          <TableCell>
            <p className="text-center">
              Δεν υπάρχουν διαθέσιμα δεδομένα στο πίνακα.
            </p>
          </TableCell>
        </TableRow>
      </TableBody>
    );
  }

  const handlePerPageDataFetch = (value) => {
    setFilter({ id: queryData.id, count: value });
  };

  const handlePagination = () => {
    fetchNextPage();
  };

  const createHeadersRegistrations = () => {
    let headers = [];
    const columns = tableDetailsData && tableDetailsData?.columns;

    if (columns && columns.length) {
      columns.forEach((itm) => {
        if (itm.show) {
          let headerTemplate = itm.label;

          headers.push(
            <TableHead key={itm.label}>
              <h6 className="whitespace-nowrap">{headerTemplate}</h6>
            </TableHead>
          );
        }
      });

      return (
        <TableHeader>
          <TableRow>{headers}</TableRow>
        </TableHeader>
      );
    }

    return '';
  };

  const createBodyRegistrations = () => {
    let rows = [];
    const columns = tableDetailsData.columns;
    let tableData = tableDetailsData.data;
    (tableData || []).forEach((itm, idx) => {
      let cells = [];
      let itmComponent;
      columns.forEach((column, colIndex) => {
        itmComponent = itm[column.name] || '';
        if (column.type === 'email') {
          itmComponent = (
            <a className="text-primary" href={`mailto:${itmComponent}`}>
              {itmComponent}
            </a>
          );
        }
        cells.push(
          <TableCell key={colIndex} className="text-body whitespace-nowrap">
            {itmComponent}
          </TableCell>
        );
      });

      rows.push(<TableRow className={itm.reason !== '' && 'bg-primary/10'} key={idx}>{cells}</TableRow>);
    });
    return <TableBody>{rows}</TableBody>;
  };

  const handleExport = (type) => {
    if (type === 'pdf') {
      generatePdfDocument(tableDetailsData, 'Οδηγοί');
    } else {
      exportToFile(tableDetailsData, type);
    }
  };

  return (
    <Container className="flex flex-col gap-6 overflow-auto h-screen max-lg:px-0">
      <BackButton
        className="max-lg:px-5"
        text="Επιστροφή"
        handleBackClick={handleBackButtonClick}
      />
      <div className="flex justify-between max-lg:px-5">
        <h2>Λεπτομέρειες Καταχώρισης</h2>
        <div className="flex gap-4">
          <PageList
            isOpen={popover}
            sizeList={tableDetailsData?.dataSize}
            handlePerPageDataFetch={(value) => {
              handlePerPageDataFetch(value);
              setPopover(false);
            }}
            setPopover={setPopover}
            defaultValue={filter.count}
          />
          <PageListMobile
            isOpen={sizeListPopoverMobile}
            sizeList={tableDetailsData?.dataSize}
            handlePerPageDataFetch={(value) => {
              handlePerPageDataFetch(value);
              setSizeListMobile(false);
            }}
            setPopover={setSizeListMobile}
            defaultValue={filter.count}
          />
          <ExportList
            isOpen={popoverExport}
            exportOptions={exportOptions}
            setPopoverExport={setPopoverExport}
            handleExport={(value) => {
              handleExport(value);
              setPopoverExport(false);
            }}
          />
          <ExportListMobile
            isOpen={popoverExportMobile}
            exportOptions={exportOptions}
            setPopoverExport={setPopoverExportMobile}
            handleExport={handleExport}
          />
        </div>
      </div>
      {isLoading && <Loader />}
      <Table wrapperClassName="p-2 lg:p-4 scrollbar overflow-auto max-lg:rounded-none">
        {createHeadersRegistrations()}
        {createBodyRegistrations()}
      </Table>
      <Pagination
        currentPage={tableDetailsData?.pagination?.current_page}
        totalCount={tableDetailsData?.records?.total}
        from={tableDetailsData?.records.from}
        to={tableDetailsData?.records.to}
        pageSize={filter.count || 25}
        onPageChange={handlePagination}
      />
    </Container>
  );
};

export default ImportDriverDetailsTable;
